import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'

import classes from './styles.module.scss'

type Props = {
  classNameRoot?: string
  classNameContent?: string
  content?: {
    title: string
    description: string
    buttonText: string
  }
}

function GameNotAvailable(props: Props) {
  return (
    <Page rootClassName={props.classNameRoot} className={props.classNameContent}>
      <div className={classes.root}>
        <div className={classes.content}>
          <h4 className={classes.title}>{props.content.title}</h4>

          <p className={classes.description}>{props.content.description}</p>

          <ButtonLink href={ROUTES.HOME} variant='contained' className={classes.btnLink}>
            {props.content.buttonText}
          </ButtonLink>
        </div>
      </div>
    </Page>
  )
}

export default GameNotAvailable
